import { z } from 'zod';
import { listResponse } from './list-response';
export const paginatedResponse = (itemSchema) => listResponse(itemSchema).extend({
    meta: z.object({
        page: z.number(),
        pageSize: z.number(),
        itemCount: z.number(),
        pageCount: z.number(),
    }),
});
